import AscTableResponsive from "../../AscTableResponsive/AscTableResponsive";

export interface ICVSTableProps {
  data: Record<string, any>[];
}

export default function AscCSVTable({ data }: ICVSTableProps) {
  return (
    <AscTableResponsive
      rowKey={
        data?.length > 0
          ? Object?.keys(data[0]).includes("id")
            ? "id"
            : Object?.keys(data[0]).includes("student_Id")
            ? "student_Id"
            : Object?.keys(data[0]).includes("email")
            ? "email"
            : "name"
          : "unknown"
      }
      columns={
        data?.length > 0
          ? Object.keys(data[0]).map((key) => {
              const lKey = key.toLowerCase();
              const isLargeContent =
                lKey.includes("email") ||
                lKey.includes("id") ||
                lKey.includes("full");
              return {
                title: key.charAt(0).toUpperCase() + key.slice(1),
                dataIndex: key,
                width: isLargeContent ? 250 : 200,
                style: {
                  overflowX: "auto",
                  whiteSpace: "nowrap",
                },
              };
            })
          : []
      }
      data={data}
    />
  );
}
